module.exports = __webpack_public_path__ + "assets/img/address.6fa6bc95.svg";